import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Util, Image, Button } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';

const ClickableImageWrapper = ({ onClick , url , labelId , hideFromKeyboardUser , children  })=>{
    const sharedProps = {
        className: 'promotion-block__link',
        'data-t': 'promotion-block-image',
        'aria-labelledby': labelId,
        onClick
    };
    if (hideFromKeyboardUser) {
        /**
     * Accessibility note:
     * If there is a CTA button shown in the PromotionBlock, then this wrapper makes the promotion image clickable
     * for a mouse user but NOT for keyboard or screen reader users. This is because the CTA <Button> natively
     * provides the same functionality and having both the image and button in the tab order is redundant for a non-mouse user
     *
     * If there is no CTA button, then the clickable image is not hidden from non-mouse users.
     *
     * In general DO NOT put an onClick on a div, unless it's a situation like this.
     *
     */ const sharedHiddenProps = swcHelpers.objectSpread({}, sharedProps, {
            'aria-hidden': true
        });
        return url ? /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
            href: url,
            tabIndex: -1
        }, sharedHiddenProps), children) : // Generally, don't put onClick on a div. See above for an explanation for this exception
        /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, sharedHiddenProps), children);
    } else {
        return url ? /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
            href: url
        }, sharedProps), children) : /*#__PURE__*/ React.createElement("button", swcHelpers.extends({}, sharedProps), children);
    }
};
const PromotionBlock = /*#__PURE__*/ React.forwardRef(({ id , title , description , image , links , size , onClick , ctaLabel , manageContentButton  }, ref)=>{
    const imageUrl = MediaQuery.useIsPhone() ? image === null || image === void 0 ? void 0 : image.mobileUrl : image === null || image === void 0 ? void 0 : image.url;
    if (!imageUrl) {
        return null;
    }
    const buttonStyles = (links === null || links === void 0 ? void 0 : links.style) ? Util.createButtonStyles(links.style) : {};
    const classNames = classnames('promotion-block', {
        'promotion-block--overlay': !!title || !!description,
        'promotion-block--large': size === 'large',
        'promotion-block--without-text': !title || !description
    });
    const promotionInfoId = `promotion-info-${id}`;
    const { url  } = links || {};
    const showCta = Boolean(!!ctaLabel && (url || onClick));
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "promotion-block",
        ref: ref,
        className: classNames
    }, manageContentButton, /*#__PURE__*/ React.createElement(ClickableImageWrapper, {
        onClick: onClick,
        url: url,
        hideFromKeyboardUser: showCta,
        labelId: promotionInfoId
    }, /*#__PURE__*/ React.createElement(Image, {
        url: imageUrl,
        cover: true,
        className: "promotion-block__image"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "promotion-block__inner"
    }, (title || description) && /*#__PURE__*/ React.createElement("div", {
        className: "promotion-block__text",
        id: promotionInfoId
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium",
        className: "promotion-block__title"
    }, title), description && /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        className: "promotion-block__subtitle"
    }, description)), showCta && /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({}, buttonStyles, {
        className: "promotion-block__button",
        "data-t": "promotion-block-button",
        size: "custom",
        "aria-describedby": promotionInfoId,
        onClick: onClick,
        href: url,
        caption: ctaLabel
    }))));
});
var PromotionBlock$1 = PromotionBlock;

export { PromotionBlock$1 as default };
//# sourceMappingURL=PromotionBlock.js.map
